import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormGroup, FormGroupLabel, ErrorMessage, RequiredMark, StyledInput } from './BaseInput';

const IntegerInput = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  required = false,
  error,
  input,
  meta,
  min = 0,
  ...props
}) => {
  // Usar input.value e input.onChange se disponível (React Final Form)
  const fieldValue = input ? input.value : value;
  const fieldOnChange = input ? input.onChange : onChange;
  const fieldName = input ? input.name : name;

  const handleChange = e => {
    const inputValue = e.target.value; // Permitir apenas números inteiros

    const numericValue = inputValue.replace(/[^0-9]/g, ''); // Aplicar valor mínimo se especificado

    let finalValue = numericValue;

    if (min !== undefined && numericValue !== '' && parseInt(numericValue, 10) < min) {
      finalValue = min.toString();
    }

    fieldOnChange(finalValue);
  };

  const handleKeyPress = e => {
    // Permitir apenas números e teclas de controle
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  return <FormGroup>
      {label && <FormGroupLabel>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </FormGroupLabel>}
      <StyledInput name={fieldName} type="text" value={fieldValue || ''} onChange={handleChange} onKeyDown={handleKeyPress} placeholder={placeholder} disabled={disabled} inputMode="numeric" pattern="[0-9]*" {...props} />
      {(error || meta && meta.touched && meta.error) && <ErrorMessage>
          {error || meta.error}
        </ErrorMessage>}
    </FormGroup>;
};

IntegerInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  min: PropTypes.number
};
export default IntegerInput;